export enum UsersActions {
    SET_USER = "setUser",
    SET_SELECTED_USERS = "setSelectedUsers",
    TOGGLE_USERS_PANEL = "toggleUsersPanel",
    RELOAD_USERS = "reloadUsers",
    CLEAR= "clearUsers",
    ADD_USER="addUser",
    REFETCH = "refetchData",
  }